import { API_URL } from '../constants';
import { fetch } from '../fetchWrapper/fetch';
import { createFormData } from 'src/helpers';
import { ICreateGlobalItemRequest, ICreateGlobalItemResponse, IGlobalItemData } from './types';

export const createGlobalItem = async (payload: ICreateGlobalItemRequest): Promise<IGlobalItemData> => {
  const requestBody = createFormData(payload);
  try {
    const response = await fetch(`${API_URL}/items/v2`, {
      method: 'POST',
      body: requestBody,
    });

    if (!response.ok) {
      throw new Error();
    }

    const { data }: ICreateGlobalItemResponse = await response.json();
    return data[0];
  } catch (e) {
    throw new Error('Something went wrong whilst creating an item');
  }
};
